import { render, staticRenderFns } from "./LanguageItem.vue?vue&type=template&id=55a1dce4&scoped=true"
import script from "./LanguageItem.vue?vue&type=script&lang=js"
export * from "./LanguageItem.vue?vue&type=script&lang=js"
import style0 from "./LanguageItem.vue?vue&type=style&index=0&id=55a1dce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a1dce4",
  null
  
)

export default component.exports